import Matchup from './Matchup';

export default Matchup;



// WEBPACK FOOTER //
// ./src/app/components/TableControls/Matchup/index.js